module.exports = new __parcel__URL__("AudioBriefingChangeboardingGifLight.ff5a7f47.gif").toString();